export const GET_CURRENT_INTERFACE = 'GET_CURRENT_INTERFACE';


